import { Link } from "react-router-dom"
import Error from "../../Layouts/Error"
import InnerHeader from "../../Layouts/InnerHeader"
import Loading from "../../Layouts/Loading"
import { fa_date, fa_number } from "../../utils/Persian"
import { useDeleteProductMutation, useGetShopProductsQuery } from "../../Redux/Apis/productApi"

const isValidUrl = (domain:string) => {
    let url;
    try {
      url = new URL(domain);
    } catch (_) {
      return false;  
    }
    return url.protocol === "http:" || url.protocol === "https:";
}

export default function Product() {
    const [deletePost] = useDeleteProductMutation()
    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error,
    } = useGetShopProductsQuery({})

    if(isLoading)
        return <Loading/>

    else if(isError)
        return <Error data={error}/>

    else if(isSuccess) {
        return(
            <div className="container-lg">
                <InnerHeader name="محصولات" linkS={{name: "محصول جدید", url: "/product/create"}} linkP={{name: "دسته‌بندی ها", url: "/product/prod-category"}}/>
                <div className="row row-cols-2 row-cols-md-3 g-4">
                    {data && data.length > 0 ? data.map((value:any,index:number) => 
                    <div className="col" key={index}>
                        <div className="card mb-3">
                            <div className="row g-0">
                                <div className="col-md-4">
                                    <img src={`${isValidUrl(value.images) ? value.images : value.url+value.images}`} className="img-fluid rounded-start" alt="product"/>
                                </div>
                                <div className="col-md-8">
                                    <div className="card-body">
                                        <h5 className="card-title">{value.name}</h5>
                                        <p className="card-text mb-0 text-secondary">دسته: {value.ProductCategory.name}</p>
                                        <p className="card-text mb-1 text-secondary">تعداد بازدید: {fa_number(value.views)}</p>
                                        <p className="card-text text-secondary">تاریخ ایجاد: <small className="text-body-secondary">{fa_date(value.create_date)}</small></p>
                                    </div>
                                </div>
                                <div className="card-footer text-end">
                                    <div className="d-grid gap-2 d-md-block justify-content-md-end">
                                        <button onClick={() => window.confirm('آیا از حذف این محصول اطمینان دارید؟') && deletePost(value.id)} className="btn btn-outline-danger me-md-2">حذف</button>
                                        <Link to={`/product/${value.id}`} className="btn btn-primary">ویرایش</Link>
                                    </div>
                                </div>
                                { value.status === 'CONFIRMED' ?
                                <span className="position-absolute top-0 end-0 translate-middle badge rounded-pill bg-success" style={{width:'auto'}}>
                                    منتشر شده
                                </span>
                                :
                                <span className="position-absolute top-0 end-0 translate-middle badge rounded-pill bg-secondary" style={{width:'auto'}}>
                                    بررسی نشده
                                </span>
                                }
                            </div>
                        </div>
                      </div>                    
                    ) :
                    <div className="alert d-flex align-items-center" role="alert">
                        <i className="zmdi zmdi-info"></i>
                        <div className="ms-2">
                        محصولی یافت نشد.
                        </div>
                    </div>
                    } 
                </div>
            </div>
        )
    }

    else return <></>
}